import {useHistoryAssetsQuery} from '@domain/assets'
import {useCurrentScheduleQuery} from '@domain/schedule'
import {
  PlanningChartScheduleDataProvider,
  SelectedScheduleItemProvider
} from '@widgets/planning-schedule-chart'
import {Moment} from 'moment-timezone'
import React from 'react'

import {OptimizerDetailsChartContainer, PlannerSkeleton} from '../components'
import {useSelectedOptimizerPlan} from '../providers'

type LayoutOptimizerSummaryProps = {
  plantCode: string
  startOfPlan: Moment
  endOfPlan: Moment
}

export const LayoutOptimizerSummary: React.FC<LayoutOptimizerSummaryProps> = ({
  plantCode,
  startOfPlan,
  endOfPlan
}: LayoutOptimizerSummaryProps) => {
  const {visibleScheduleId} = useSelectedOptimizerPlan()

  const {data: sortedAssets} = useHistoryAssetsQuery({
    plantId: plantCode,
    timeFrame: [startOfPlan, endOfPlan],
    sorted: true
  })
  const {data: manualSchedule} = useCurrentScheduleQuery({
    plantId: plantCode,
    range: [startOfPlan, endOfPlan]
  })

  return (
    <SelectedScheduleItemProvider>
      <div>
        <PlanningChartScheduleDataProvider scheduleId={visibleScheduleId}>
          {sortedAssets && manualSchedule ? (
            <OptimizerDetailsChartContainer plantCode={plantCode} sortedAssets={sortedAssets} />
          ) : (
            <PlannerSkeleton height="40vh" />
          )}
        </PlanningChartScheduleDataProvider>
      </div>
    </SelectedScheduleItemProvider>
  )
}
